export default __webpack_public_path__ + "static/media/newRot.15e709c2.png";